import { render, staticRenderFns } from "./modal_criar_agenda.vue?vue&type=template&id=6c7a86bd&scoped=true&"
import script from "./modal_criar_agenda.vue?vue&type=script&lang=js&"
export * from "./modal_criar_agenda.vue?vue&type=script&lang=js&"
import style0 from "./modal_criar_agenda.vue?vue&type=style&index=0&id=6c7a86bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7a86bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VRadio,VRadioGroup,VSelect,VTextField})
